import React from "react";
import Header from "../../../Components/Header";
import ClientDetailsOmsComp from "../../../Components/OMS/ClientDetailsOms/ClientDetailsOmsComp";
import PreviousObjectionList from "../../../Components/OMS/ClientDetailsOms/PreviousObjectionList";
import RejectionTypeComp from "../../../Components/OMS/ClientDetailsOms/RejectionTypeOms";
import SingleSignOnSideBar from "../../../Components/SingleSignOnSideBar";
import { OMSHNI } from "../../../Configuration/Telecaller_URl";

function ClientDetailsOmsHni() {
  const storeToken = localStorage.getItem("ssoToken");
  if (storeToken == null) {
    window.location.replace("/");
  }

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="omspage">
          <ClientDetailsOmsComp
            URL={OMSHNI.OMS_CLIENT_DETAILS_HNI_URL}
            mainType={"HNI"}
          />
          <RejectionTypeComp
            URL={{
              addObjections: OMSHNI.ADD_OBJECTION_HNI_URL,
              getObjections: OMSHNI.GET_OBJECTIONS_HNI_URL,
              saveRejections: OMSHNI.SAVE_REJECTION_HNI_URL,
            }}
            mainType={"HNI"}
          />
          <PreviousObjectionList
            URL={OMSHNI.PRIVIOUS_OBJECTION_HNI_URL}
            mainType={"HNI"}
          />
        </div>
      </main>
    </>
  );
}

export default ClientDetailsOmsHni;
